import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';
import LocallyGrownFlashImages from "./LocallyGrownFlashImages";

class LocallyGrown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locallygrownpage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "locallygrownNew",
    }).then((entries) => {
      this.setState({ locallygrownpage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(locallygrownDescription) {
    return {
      __html: marked(locallygrownDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.locallygrownpage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.locallygrownpage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.locallygrownTitle}</h1>
                    <h2 className="lead">{item.fields.locallygrownShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.locallygrownImg.fields.file.url}
                          alt="locally grown"
                        />
                        
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.locallygrownDescription
                        )}>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

          <div className="pt-4">
            <Link to="/locally-grown-gallery"><LocallyGrownFlashImages/></Link>  
          </div>

      {/* <div className="pt-4">
      <Link to="/locally-grown-gallery"><button className="btn btn-primary">View Gallery</button></Link>
      </div> */}
      </div>
      
      </>
    );
  }
}

export default LocallyGrown;
